// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conn-form-plain-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.conn-form-plain-text__hint .yfm p {
  color: var(--g-color-text-hint);
  line-height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/connections/components/ConnectorForm/components/PlainText/PlainText.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AACJ;AACI;EACI,+BAAA;EACA,iBAAA;AACR","sourcesContent":[".conn-form-plain-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.conn-form-plain-text__hint .yfm p {\n  color: var(--g-color-text-hint);\n  line-height: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
